module.exports = __webpack_public_path__ + "static/media/3DPPA30.de353d53.jpg";